import { createContext, useState } from "react";
import { DefaultToken, Token } from "./token";
import antimatterAbi from "artifacts/contracts/tokens/AntiMatter.sol/AntiMatter.json";
import matterAbi from "artifacts/contracts/tokens/Matter.sol/Matter.json";
import energyAbi from "artifacts/contracts/tokens/Energy.sol/Energy.json";
import { metaverse } from "data/metaverse";

export const defaults = {
  matter: DefaultToken(metaverse.matter, matterAbi.abi),
  antimatter: DefaultToken(metaverse.antimatter, antimatterAbi.abi),
  energy: DefaultToken(metaverse.energy, energyAbi.abi),
};

type Metaverse = {
  matter: Token;
  setMatter: React.Dispatch<React.SetStateAction<Token>>;

  antimatter: Token;
  setAntimatter: React.Dispatch<React.SetStateAction<Token>>;

  energy: Token;
  setEnergy: React.Dispatch<React.SetStateAction<Token>>;
};

export const MetaverseContext = createContext({} as Metaverse);

export function MetaverseProvider(props: { children?: React.ReactNode }) {
  const [matter, setMatter] = useState<Token>(defaults.matter);
  const [antimatter, setAntimatter] = useState<Token>(defaults.antimatter);
  const [energy, setEnergy] = useState<Token>(defaults.energy);
  return (
    <MetaverseContext.Provider value={{ matter, setMatter, antimatter, setAntimatter, energy, setEnergy }} {...props} />
  );
}
